import React, { FC, HTMLProps } from "react";
import { useStyles } from "./IconStyles";

const AppStore: FC<HTMLProps<HTMLImageElement>> = ({ ...props }) => {
  const styles = useStyles();

  return (
    <span className={styles.imageWrapper}>
      <img {...props} />
    </span>
  );
};

export default AppStore;
